import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import * as bucketSelectors from '../selectors/bucketSelectors';
import routes from '../helpers/ApplicationRoutes';

export default function isAuthorizedCurrentBucket(
    WrappedComponent,
    adminOnly = false,
) {
    class CurrentBucketAuthorization extends React.Component {
        constructor(props) {
            super(props);
            this.state = {
                // undefined means that resources needed to check
                // authorization are not loaded
                authorized: undefined,
            };
        }

        componentDidMount() {
            this.checkAutorization();
        }

        componentDidUpdate() {
            this.checkAutorization();
        }

        checkAutorization() {
            const { _bucket, _isBucketAdmin, _isLoadingBuckets } = this.props;

            const { authorized } = this.state;

            if (
                _isLoadingBuckets === undefined ||
                _isLoadingBuckets ||
                authorized !== undefined
            ) {
                return;
            }

            if (_bucket) {
                if (adminOnly) {
                    this.setState({ authorized: _isBucketAdmin });
                } else {
                    this.setState({ authorized: true });
                }
            } else {
                this.setState({ authorized: false });
            }
        }

        render() {
            const { authorized } = this.state;
            const {
                _bucket,
                _isBucketAdmin,
                _isLoadingBuckets,
                ...rest
            } = this.props;
            if (authorized === undefined) {
                // waiting for resources to load to determine if user is authorized
                return null;
            }
            if (authorized) {
                return <WrappedComponent {...rest} />;
            }
            console.error(`Not authorized to see page ${window.location}`);
            return <Redirect to={routes.root.getPath()} />;
        }
    }

    const mapStateToProps = state => ({
        _bucket: bucketSelectors.getBucket(state),
        _isLoadingBuckets: bucketSelectors.getIsLoadingBuckets(state),
        _isBucketAdmin: bucketSelectors.getIsCurrentUserAdminForCurrentBucket(
            state,
        ),
    });

    return connect(mapStateToProps)(CurrentBucketAuthorization);
}



// WEBPACK FOOTER //
// ./src/hoc/CurrentBucketAuthorization.js